import { CountryMultiplierDto, CreateCountryMultiplierDto } from "../store/types"

export const mockCountryMultipliers: CountryMultiplierDto[] = [
  {
    id: "multiplier-1",
    gameId: 7314,
    countryCode: "US",
    countryGroupId: null,
    multiplier: 1.5,
    createdAt: new Date("2024-01-15"),
    updatedAt: new Date("2024-01-15"),
  },
  {
    id: "multiplier-2",
    gameId: null,
    countryCode: null,
    countryGroupId: "group-1",
    multiplier: 1.2,
    createdAt: new Date("2024-01-16"),
    updatedAt: new Date("2024-01-16"),
  },
  {
    id: "multiplier-3",
    gameId: 5426,
    countryCode: null,
    countryGroupId: "group-2",
    multiplier: 1.8,
    createdAt: new Date("2024-01-17"),
    updatedAt: new Date("2024-01-17"),
  },
  {
    id: "multiplier-4",
    gameId: null,
    countryCode: "GB",
    countryGroupId: null,
    multiplier: 1.0,
    createdAt: new Date("2024-01-18"),
    updatedAt: new Date("2024-01-18"),
  },
  {
    id: "multiplier-5",
    gameId: 7764,
    countryCode: "GB",
    countryGroupId: null,
    multiplier: 1.3,
    createdAt: new Date("2024-01-19"),
    updatedAt: new Date("2024-01-19"),
  },
]

export const getMockCountryMultipliers = (): Promise<CountryMultiplierDto[]> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(mockCountryMultipliers)
    }, 500)
  })
}

export const getMockCountryMultiplierById = (id: string): Promise<CountryMultiplierDto> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const multiplier = mockCountryMultipliers.find(m => m.id === id)
      if (!multiplier) {
        reject(new Error(`Country multiplier with id ${id} not found`))
      } else {
        resolve(multiplier)
      }
    }, 500)
  })
}

export const createMockCountryMultiplier = (data: CreateCountryMultiplierDto): Promise<CountryMultiplierDto> => {
  return new Promise(resolve => {
    setTimeout(() => {
      const newMultiplier: CountryMultiplierDto = {
        id: `multiplier-${Date.now()}`,
        gameId: data.gameId ?? null,
        countryCode: data.countryCode ?? null,
        countryGroupId: data.countryGroupId ?? null,
        multiplier: data.multiplier,
        createdAt: new Date(),
        updatedAt: new Date(),
      }
      mockCountryMultipliers.push(newMultiplier)
      resolve(newMultiplier)
    }, 500)
  })
}

export const updateMockCountryMultiplier = (id: string, data: CreateCountryMultiplierDto): Promise<CountryMultiplierDto> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = mockCountryMultipliers.findIndex(m => m.id === id)
      if (index === -1) {
        reject(new Error(`Country multiplier with id ${id} not found`))
      } else {
        mockCountryMultipliers[index] = {
          ...mockCountryMultipliers[index],
          gameId: data.gameId ?? null,
          countryCode: data.countryCode ?? null,
          countryGroupId: data.countryGroupId ?? null,
          multiplier: data.multiplier,
          updatedAt: new Date(),
        }
        resolve(mockCountryMultipliers[index])
      }
    }, 500)
  })
}

export const deleteMockCountryMultiplier = (id: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const index = mockCountryMultipliers.findIndex(m => m.id === id)
      if (index === -1) {
        reject(new Error(`Country multiplier with id ${id} not found`))
      } else {
        mockCountryMultipliers.splice(index, 1)
        resolve()
      }
    }, 500)
  })
}
